import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";
export const ProductSchema = Yup.object({
  price: Yup.string()
    .required(msg("priceRequired"))
    .matches(validationPatterns.number, msg("onlyNumbers")),
  stock: Yup.string()
    .required(msg("stockRequired"))
    .matches(validationPatterns.number, msg("onlyNumbers")),

  name: Yup.string().required(msg("nameRequiredDot")),
  description: Yup.string().required(msg("descriptionRequired")),
  sub_categories: Yup.mixed().required(msg("subCategoryRequired")),
  categories: Yup.mixed().required(msg("categoryRequired")),
});
